import HomePageCard from '../components/HomePageCard';
import GiftOutline from '../components/icons/GiftOutline';
import LightBulbOutline from '../components/icons/LightBulbOutline';
import ShareOutline from '../components/icons/ShareOutline';
import NotVerifiedAlert from '../components/NotVerifiedAlert';
import { useAppContext } from '../context/AppContext';

const HomePage = () => {
  const { user } = useAppContext();

  return (
    <div style={{ margin: '2rem' }} className="space-y-6">
      <div className="flex flex-row justify-between items-center">
        <h1 className="text-white text-xl">
          <b>Mt Bringsl</b>
        </h1>
      </div>
      {!user.verified && <NotVerifiedAlert />}
      <div className="flex flex-row gap-4 flex-wrap">
        <HomePageCard
          title="Meine Wünsche"
          Icon={<GiftOutline className="w-10 h-10 mb-2 text-gray-400" />}
          href="/my-wishes"
          linkTitle="Zur Seite"
          text="Eigene Wünsche festhalten und teilen."
        />
        <HomePageCard
          title="Meine Ideen"
          Icon={<LightBulbOutline className="w-10 h-10 mb-2 text-gray-400" />}
          href="/ideas"
          linkTitle="Zur Seite"
          text="Zu beschenkende Personen anlegen und Ideen für diese festhalten."
        />
        <HomePageCard
          title="Mit mir geteilt"
          Icon={<ShareOutline className="w-10 h-10 mb-2 text-gray-400" />}
          href="/shared-with-me"
          linkTitle="Zur Seite"
          text="Andere Nutzer, welche ihre Wünsche mit dir geteilt haben."
        />
      </div>
    </div>
  );
};

export default HomePage;
